var StringUtils = {


	isFilled : function(string) {
		return typeof string !== 'undefined' && string.length;
	},

	get_param : function(key) {
		var url_string = window.location.href;
		var url = new URL(url_string);
		return url.searchParams.get(key); 
	},

	dollar_format : function(amount, rounding = false) {
		if(!amount) return '$0.00';
		if(!rounding) return '$' + StringUtils.numberWithCommas(parseFloat(amount).toFixed(2));

		return '$' + StringUtils.numberWithCommas(Math.round(parseFloat(amount)));
	},

	numberWithCommas : function(x) {
    	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

}

export default StringUtils;